import type { FC } from 'react';
import type { IconType } from 'react-icons';
import { TbBone, TbHealthRecognition, TbHome2, TbPaw, TbScissors } from 'react-icons/tb';
import type { CustomIconProps } from './types';

const iconMap: Record<CustomIconProps['name'], IconType> = {
  'tb-paw': TbPaw,
  'tb-home': TbHome2,
  'tb-health-recognition': TbHealthRecognition,
  'tb-bone': TbBone,
  'tb-scissors': TbScissors,
};

export const CustomIcon: FC<CustomIconProps> = (props) => {
  const { name, color } = props;
  const IconComponent = iconMap[name];
  return <IconComponent color={color} />;
};
